import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Mail, RefreshCw, Trash2 } from 'lucide-react';

const ContactsList = ({ contacts, onRefresh, onDelete }) => (
  <Card className="p-6">
    <div className="flex justify-between items-center mb-6">
      <h3 className="text-lg font-bold text-gray-900">All Contact Submissions</h3>
      <Button
        onClick={onRefresh}
        className="bg-indigo-600 hover:bg-indigo-700 text-white"
        size="sm"
        data-testid="contacts-refresh-btn"
      >
        <RefreshCw className="h-4 w-4 mr-2" />
        Refresh
      </Button>
    </div>

    {contacts.length === 0 ? (
      <p className="text-gray-500 text-center py-12">No contact submissions yet</p>
    ) : (
      <div className="space-y-4">
        {contacts.map((contact) => (
          <Card key={contact.id} className="p-4 border border-gray-200" data-testid={`contact-card-${contact.id}`}>
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h4 className="font-bold text-gray-900">{contact.name}</h4>
                  <span className="text-xs bg-indigo-100 text-indigo-700 px-2 py-1 rounded">
                    {new Date(contact.created_at).toLocaleString()}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-2">
                  <Mail className="inline h-4 w-4 mr-1" />
                  {contact.email}
                </p>
                <div className="bg-gray-50 p-3 rounded mt-3">
                  <p className="text-sm text-gray-700 whitespace-pre-wrap">{contact.message}</p>
                </div>
              </div>
              <Button
                onClick={() => onDelete(contact.id)}
                className="bg-red-100 hover:bg-red-200 text-red-700"
                size="sm"
                data-testid={`contact-delete-${contact.id}`}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </Card>
        ))}
      </div>
    )}
  </Card>
);

export default ContactsList;
